import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3a3dce70"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "view add-moderator" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "users__header" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "users__title" }, "Add moderator")
], -1))
const _hoisted_3 = { class: "add-moderator__form-panel" }
const _hoisted_4 = { class: "add-moderator__form-section" }
const _hoisted_5 = { class: "add-moderator__form-box" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "add-moderator__headline" }, "Informations", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "add-moderator__text" }, "Provide all informations to add a moderator", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "email" }, "Email", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Name", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "add-moderator__actions" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "button button--green" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "material-icons left" }, "add"),
    /*#__PURE__*/_createTextVNode(" Add Moderator")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("form", {
      onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _hoisted_7,
            _hoisted_8,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              name: "email",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.moderator.email) = $event)),
              required: ""
            }, null, 512), [
              [_vModelText, _ctx.moderator.email]
            ]),
            _hoisted_9,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              name: "name",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.moderator.name) = $event)),
              required: ""
            }, null, 512), [
              [_vModelText, _ctx.moderator.name]
            ])
          ])
        ])
      ]),
      _hoisted_10
    ], 32)
  ]))
}